import { Flex, type MantineSize, Text, type TextProps } from '@mantine/core'
import { type ComponentType } from 'react'

import { type UNSAFE_any, type CoreProduct } from '@flecto/types'

import {
  BadgeProductBundle,
  type BadgeProductBundlePopoverDefault,
  type BadgeProductBundlePopoverOverrideProps,
} from '../BadgeProductBundle/BadgeProductBundle'
import { BadgeProductInsurance } from '../BadgeProductInsurance/BadgeProductInsurance'

export type TextProductTitleProps<
  C extends ComponentType<UNSAFE_any> = BadgeProductBundlePopoverDefault,
> = TextProps & {
  product?: CoreProduct
  size?: MantineSize
  withBadgeInsurance?: boolean
  withBadgeBundle?: boolean
} & BadgeProductBundlePopoverOverrideProps<C>

export function TextProductTitle<
  C extends ComponentType<UNSAFE_any> = BadgeProductBundlePopoverDefault,
>({
  product,
  size,
  popoverComponent,
  popoverProps,
  withBadgeInsurance = true,
  withBadgeBundle = true,
  ...props
}: TextProductTitleProps<C>) {
  return (
    <Flex align='center' gap='sm' wrap='wrap'>
      <Text
        data-testid='product-title'
        size={size}
        fw={500}
        truncate
        {...props}
      >
        {product?.title}
      </Text>
      {withBadgeInsurance && (
        <BadgeProductInsurance
          data-testid='badge-product-insurance'
          product={product}
        />
      )}
      {withBadgeBundle && (
        <BadgeProductBundle
          data-testid='badge-product-bundle'
          product={product}
          popoverComponent={popoverComponent}
          popoverProps={popoverProps}
        />
      )}
    </Flex>
  )
}
